import { deleteRequest, get, post, publicPost, put } from "../helpers/apihelpers";

export const CreateWebsiteMessageService=async(data)=>{
    try {
        const result = await post(`api/website_contact_form/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateWebsiteMessageService=async(data,id)=>{
    try {
        const result = await put(`api/website_contact_form/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetWebsiteMessageService=async(page,from_date,to_date,text)=>{
    try {
        const result = await get(`api/website_contact_form/get?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const DeleteWebsiteMessageService=async(id)=>{
    try {
        const result = await deleteRequest(`api/website_contact_form/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}